(function(){
  var gf = document.getElementById('GiftFinder');
  if(!gf) return;
  var titleEl = document.getElementById('GfTitle');
  var dots = gf.querySelectorAll('.gf__dots span');
  var steps = gf.querySelectorAll('.gf__step');
  var backBtn = document.getElementById('GfBack');
  var summaryEl = document.getElementById('GfSummary');
  var seeBtn = document.getElementById('GfSee');
  var restartBtn = document.getElementById('GfRestart');
  var lastFocus = null;
  var state = { recipient:null, category:null, budget:null };
  var current = 1;
  var titles = { 1:'Who are you gifting for?', 2:'What are they into?', 3:'What is your budget?' };

  // Recipient -> gender bucket. Drives which collection each interest resolves to.
  var genderOf = { her:'fem', sister:'fem', him:'masc', brother:'masc', parents:'neutral', colleague:'neutral', surprise:'neutral' };

  // Interest x gender -> a real, in-stock collection handle. This is the single source of routing truth.
  var routes = {
    accessories: { fem:'fashion-accessories', masc:'men',             neutral:'fashion-accessories' },
    bags:        { fem:'bags',                masc:'bags',            neutral:'bags' },
    stoles:      { fem:'stoles',              masc:'mens-scraf',      neutral:'stoles' },
    home:        { fem:'home-decor',          masc:'home-decor',      neutral:'home-decor' },
    art:         { fem:'painting',            masc:'painting',        neutral:'painting' },
    candles:     { fem:'candle',              masc:'candle',          neutral:'candle' },
    brass:       { fem:'brass-handicraft',    masc:'brass-handicraft',neutral:'brass-handicraft' }
  };

  // "Surprise me" or no interest picked -> broadest well-stocked collection for that person.
  var anyMap = { her:'women', sister:'gift-for-sister', him:'men', brother:'gift-for-brother', parents:'gift-hampers-gift-sets', colleague:'gift-hampers-gift-sets', surprise:'gift-hampers-gift-sets' };

  var recipientLabel = { her:'her', him:'him', sister:'your sister', brother:'your brother', parents:'your parents', colleague:'a colleague', surprise:'someone special' };
  var categoryLabel = { accessories:'jewellery & accessories', bags:'bags & clutches', stoles:'scarves & stoles', home:'home & decor', art:'art & paintings', candles:'candles & festive', brass:'brass & spiritual', any:'a curated mix' };
  var budgetLabel = { b1:'under Rs. 1,000', b2:'Rs. 1,000 to 2,500', b3:'Rs. 2,500 to 5,000', b4:'above Rs. 5,000', any:'any budget' };
  var budgetParams = { b1:{lte:'1000',sort:'price-ascending'}, b2:{gte:'1000',lte:'2500'}, b3:{gte:'2500',lte:'5000'}, b4:{gte:'5000',sort:'price-descending'}, any:{} };

  var priceAvail = {
    'gift-for-her': {b1:false,b2:true,b3:false,b4:true},
    'gift-for-him': {b1:false,b2:true,b3:false,b4:false},
    'gift-for-sister': {b1:false,b2:true,b3:true,b4:true},
    'gift-for-brother': {b1:false,b2:true,b3:true,b4:true},
    'gift-hampers-gift-sets': {b1:false,b2:true,b3:true,b4:false},
    'prayasa-gifting': {b1:false,b2:true,b3:false,b4:false},
    'fashion-accessories': {b1:false,b2:true,b3:true,b4:true},
    'bags': {b1:false,b2:true,b3:true,b4:false},
    'stoles': {b1:false,b2:false,b3:true,b4:true},
    'home-decor': {b1:true,b2:true,b3:true,b4:true},
    'painting': {b1:false,b2:false,b3:true,b4:true},
    'candle': {b1:true,b2:false,b3:true,b4:false},
    'brass-handicraft': {b1:false,b2:true,b3:true,b4:false},
    'mens-scraf': {b1:false,b2:true,b3:true,b4:false},
    'men': {b1:false,b2:true,b3:true,b4:true},
    'women': {b1:false,b2:true,b3:true,b4:true},
    'pocket-squares': {b1:false,b2:true,b3:true,b4:true},
    'bow-for-men': {b1:false,b2:true,b3:false,b4:false}
  };

  function pickHandle(){
    var r = state.recipient, c = state.category;
    var g = genderOf[r] || 'neutral';
    if(!c || c === 'any'){ return anyMap[r] || 'gift-hampers-gift-sets'; }
    var row = routes[c];
    if(row){ return row[g] || row.neutral || 'gift-hampers-gift-sets'; }
    return anyMap[r] || 'gift-hampers-gift-sets';
  }

  function buildUrl(){
    var handle = pickHandle();
    var b = budgetParams[state.budget] || {};
    var q = [];
    if(b.gte) q.push('filter.v.price.gte=' + b.gte);
    if(b.lte) q.push('filter.v.price.lte=' + b.lte);
    if(b.sort) q.push('sort_by=' + b.sort);
    return '/collections/' + handle + (q.length ? ('?' + q.join('&')) : '');
  }

  function applyBudgetAvailability(){
    var handle = pickHandle();
    var avail = priceAvail[handle];
    gf.querySelectorAll('[data-budget]').forEach(function(btn){
      var key = btn.getAttribute('data-budget');
      var ok = (key === 'any') || !avail || !!avail[key];
      btn.classList.toggle('gf__opt--unavail', !ok);
      if(ok){ btn.removeAttribute('aria-disabled'); btn.removeAttribute('tabindex'); }
      else { btn.setAttribute('aria-disabled','true'); btn.setAttribute('tabindex','-1'); }
      var note = btn.querySelector('.gf__unavail-note');
      if(!ok && !note){
        note = document.createElement('span');
        note.className = 'gf__unavail-note';
        note.textContent = 'Nothing here yet';
        btn.appendChild(note);
      } else if(ok && note){ note.remove(); }
    });
  }

  function setStep(n){
    current = n;
    if(n === 3){ applyBudgetAvailability(); }
    steps.forEach(function(s){ s.classList.toggle('is-active', String(n) === s.getAttribute('data-step')); });
    if(n <= 3){ titleEl.textContent = titles[n]; }
    dots.forEach(function(d,i){ d.classList.toggle('on', i === Math.min(n,3) - 1); });
    backBtn.hidden = (n === 1 || n === 4);
    gf.querySelector('.gf__body').scrollTop = 0;
  }

  function finish(){
    var parts = [];
    if(state.recipient) parts.push('Gifts for ' + recipientLabel[state.recipient]);
    if(state.category && state.category !== 'any') parts.push(categoryLabel[state.category]);
    parts.push(budgetLabel[state.budget]);
    summaryEl.textContent = parts.join(', ') + '.';
    seeBtn.setAttribute('href', buildUrl());
    setStep(4);
  }

  function open(){
    lastFocus = document.activeElement;
    state = { recipient:null, category:null, budget:null };
    setStep(1);
    gf.classList.add('gf--open');
    gf.setAttribute('aria-hidden','false');
    document.documentElement.classList.add('gf-lock');
    document.body.classList.add('gf-lock');
    var c = gf.querySelector('.gf__close'); if(c) c.focus();
  }
  function close(){
    gf.classList.remove('gf--open');
    gf.setAttribute('aria-hidden','true');
    document.documentElement.classList.remove('gf-lock');
    document.body.classList.remove('gf-lock');
    if(lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function(e){
    if(e.target.closest('[data-gift-finder-open]')){ e.preventDefault(); open(); }
  });
  gf.addEventListener('click', function(e){ if(e.target.closest('[data-gf-close]')) close(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && gf.classList.contains('gf--open')) close(); });

  gf.addEventListener('click', function(e){
    var opt = e.target.closest('.gf__opt'); if(!opt) return;
    if(opt.hasAttribute('data-recipient')){ state.recipient = opt.getAttribute('data-recipient'); setStep(2); }
    else if(opt.hasAttribute('data-category')){ state.category = opt.getAttribute('data-category'); setStep(3); }
    else if(opt.hasAttribute('data-budget')){
      if(opt.classList.contains('gf__opt--unavail')) return;
      state.budget = opt.getAttribute('data-budget'); finish();
    }
  });

  backBtn.addEventListener('click', function(){ if(current > 1) setStep(current - 1); });
  restartBtn.addEventListener('click', function(){ state = { recipient:null, category:null, budget:null }; setStep(1); });
})();
